import { Injectable } from '@angular/core';
import { Api } from '../../contracts/classes/api.class';
import { Observable } from 'rxjs';
import { IResponse } from '../../contracts/models/response.model';
import { CreateTypeHorarioDTO, TypeHorario, updateOrderTypeHorarioDTO, UpdateTypeHorarioDTO } from '../../contracts/models/type-horario.model';

@Injectable({
  providedIn: 'root'
})
export class TypeHorarioService extends Api {

  getAll(): Observable<IResponse<TypeHorario[]>> {
    return this.http.get<IResponse<TypeHorario[]>>(`${this.url}/tipoHorario`);
  }

  create(createTypeEmailDTO: CreateTypeHorarioDTO): Observable<IResponse<TypeHorario>> {
    return this.http.post<IResponse<TypeHorario>>(`${this.url}/tipoHorario`, createTypeEmailDTO);
  }

  update(UpdateTypeHorarioDTO: UpdateTypeHorarioDTO): Observable<IResponse<TypeHorario>> {
    return this.http.put<IResponse<TypeHorario>>(`${this.url}/tipoHorario/${UpdateTypeHorarioDTO.id}`, UpdateTypeHorarioDTO);
  }

  delete(id: number): Observable<IResponse<TypeHorario>> {
    return this.http.delete<IResponse<TypeHorario>>(`${this.url}/tipoHorario/${id}`);
  }

  updateOrder(updateOrderTypeHorarioDTO: updateOrderTypeHorarioDTO[]): Observable<IResponse<TypeHorario[]>> {
    return this.http.put<IResponse<TypeHorario[]>>(`${this.url}/tipoHorario/data/updateOrder`, {
      tipoHorarios: updateOrderTypeHorarioDTO
    });
  }
}
